import React from 'react';
import { HardHat } from 'lucide-react';

export const Header: React.FC = () => {
  return (
    <header className="bg-slate-800 text-white shadow-md">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <HardHat className="h-8 w-8 text-yellow-400" />
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight">
              Asphalt Calculator
            </h1>
          </div>
          <div className="hidden md:block">
            <nav className="flex space-x-6">
              <a href="#features" className="hover:text-yellow-400 transition-colors">Features</a>
              <a href="#calculator" className="hover:text-yellow-400 transition-colors">Calculator</a>
              <a href="#about" className="hover:text-yellow-400 transition-colors">About</a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};